import { useMemo } from 'react';
import { useNewObjectIdsContext } from './ReconciliationLocalMutationsProvider';
export const useNewObjectIds = () => {
  const context = useNewObjectIdsContext();
  return useMemo(() => context.newObjectIds, [context.newObjectIds]);
};